import React from 'react';
import PGSolutionWorkflowIllustration from './PGSolutionWorkflowIllustration';
import { useTranslation } from 'react-i18next';

const stages = [
  { id: 'prepare', start: 1, steps: ['create', 'syntax', 'cycleTime'] },
  { id: 'simulate', start: 4, steps: ['collision', 'result'] },
  { id: 'manage', start: 6, steps: ['send', 'manage'] },
];

export default function PGSolutionWorkflow() {
  const { t } = useTranslation('app');
  const copy = (key) => t(`productIntro.pgSolution.workflow.${key}`);

  return (
    <section className="pg-workflow" aria-labelledby="pg-workflow-title">
      <div className="hicps-container">
        <h2 id="pg-workflow-title">{copy('title')}</h2>
        <p className="pg-workflow-intro">{copy('description')}</p>
        <ol className="pg-workflow-stages">
          {stages.map((stage, index) => (
            <li className="pg-workflow-stage" key={stage.id}>
              <div className="pg-workflow-visual">
                <div className="pg-workflow-stage-label">
                  <span>{String(index + 1).padStart(2, '0')}</span>
                  <strong>{copy(`${stage.id}.label`)}</strong>
                </div>
                <PGSolutionWorkflowIllustration stage={stage.id} />
                <div className="pg-workflow-tags">
                  {(stage.id === 'prepare' ? ['template', 'guide'] : stage.steps).map((tag) => (
                    <span key={tag}>{copy(`tags.${tag}`)}</span>
                  ))}
                </div>
              </div>
              <div className="pg-workflow-copy">
                <h3>{copy(`${stage.id}.title`)}</h3>
                <ol start={stage.start} className="pg-workflow-steps">
                  {stage.steps.map((step) => (
                    <li key={step}>
                      <h4>{copy(`steps.${step}.title`)}</h4>
                      <p>{copy(`steps.${step}.description`)}</p>
                    </li>
                  ))}
                </ol>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}

